import React from "react";
import "tippy.js/dist/tippy.css";
import IconButton from "./IconButton";
import { useTranslation } from 'react-i18next';

const InfoButton = ({show = true, onClick, tooltip}) => {

    const { t } = useTranslation();

    return (
        <>
            <IconButton
                show={show}
                className={"mr-2"}
                variant="outline-primary"
                onClick={onClick}
                icon="fa-info"
                tooltip={tooltip || t("common.details")}
            />
        </>
    );
};


export default InfoButton;